import { State } from './states';

export type StateAbbreviation = keyof typeof State;

export const StateAbbreviations: Readonly<Record<StateAbbreviation, StateAbbreviation>> = Object.freeze(
  Object.fromEntries(Object.keys(State).map((key: string) => [key, key])),
) as Readonly<Record<StateAbbreviation, StateAbbreviation>>;
